var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSealed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.601562,
    y: 0.343262,
    width: 37.8012,
    height: 37.8012,
    rx: 18.9006,
    fill: "#636363"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8651 10.764C20.8651 10.4327 20.594 10.1616 20.2627 10.1616H17.782C17.4507 10.1616 17.1797 10.4327 17.1797 10.764V12.3225H20.8651V10.764Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6717 13.226H15.3683C14.8714 13.226 14.4648 13.6325 14.4648 14.1295V26.568C14.4648 27.0649 14.8714 27.4715 15.3683 27.4715H22.6717C23.1686 27.4715 23.5752 27.0649 23.5752 26.568V14.1295C23.5752 13.6325 23.1686 13.226 22.6717 13.226ZM19.02 23.3353C17.3705 23.3353 16.0333 21.9984 16.0333 20.3489C16.0333 18.6994 17.3705 17.3622 19.02 17.3622C20.6695 17.3622 22.0067 18.6994 22.0067 20.3489C22.0067 21.9984 20.6695 23.3353 19.02 23.3353Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6226 18.1239H18.418V20.985H21.2791V19.7803H19.6226V18.1239Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSealed);
export default __webpack_public_path__ + "static/media/sealed.c97d1f3ef6cb9cdf87a369bffce5dc87.svg";
export { ForwardRef as ReactComponent };